import {DropdownMultiSelect} from "common";
import {ReactDatePickerProps} from "react-datepicker";
import {memo, useMemo} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {
    AddendumRequestReasonMap,
    ClientReportReportType,
    ClientReportReportTypeMap,
    ClientReportSubmitInput, ShortAddendumRequestReasonMap
} from "../domain";
import {SPLIT_DELIMITER, splitAndRemoveEmpty} from "../../../placement/const";

type AddendumRequestReasonInputProps = {
    sending: boolean
} & Omit<ReactDatePickerProps, 'onChange'>;
export const AddendumRequestReasonInput = memo(({
                                                    sending,
                                                    ...datePickerProps
                                                }: AddendumRequestReasonInputProps) => {
    const {
        control,
        watch,
        setValue,
        clearErrors,
        formState: {
            errors
        }
    } = useFormContext<ClientReportSubmitInput>();

    const reportType = watch('reportType');
    const options = useMemo(
        () => Array.from(
            ClientReportReportTypeMap.get(reportType) === ClientReportReportType.ABA_SHORT_ADDENDUM
                ? ShortAddendumRequestReasonMap.keys()
                : AddendumRequestReasonMap.keys()
        ),
        [reportType],
    );


    return (
        <div className="text-black-200 pb-2 items-center text-base">
            <div className='flex'>
                <div className="w-2/6 text-right">
                    <div>Addendum Request Reasons</div>
                    <div className={'text-xs'}>(select all that apply)</div>
                </div>
                <div className="w-3/6 ml-4 flex items-center">
                    <Controller
                        name="addendumRequestReason"
                        control={control}
                        rules={{
                            required: true
                        }}
                        render={({field: {value}}) => {

                            return (
                                <DropdownMultiSelect
                                    width={'w-full'}
                                    field='addendumRequestReason'
                                    placeholder={'-  Addendum Request Reason'}
                                    options={options}
                                    labelMapperFunc={(val) => AddendumRequestReasonMap.get(val)!}
                                    value={value.join(SPLIT_DELIMITER)}
                                    setValue={(values) => {
                                        setValue("addendumRequestReason", splitAndRemoveEmpty(values));
                                        clearErrors("addendumRequestReason");
                                    }}
                                    hasError={errors.addendumRequestReason !== undefined}
                                />
                            );
                        }}/>
                </div>
            </div>

            {
                errors.addendumRequestReason &&
                <div className='flex'>
                    <div className={'w-2/6'}/>
                    <div className="w-3/6 ml-4 items-center text-red-700">
                        Please select at least 1 option for the Addendum Request Reason field
                    </div>
                </div>
            }
        </div>
    );
});
